"use client";

import {
	Area,
	AreaChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { ChartTooltip } from "../../components/chart-tooltip";
import type { ChartDataItem } from "../../utils/chart-values";
import { oxfordChartConfig } from "./utils";

interface OxfordChartProps {
	chartData: ChartDataItem[];
}

export function OxfordChart({ chartData }: OxfordChartProps) {
	// Filter out data points with no entries
	const filteredData = chartData.filter((point) => point.entries_count > 0);

	return (
		<ResponsiveContainer width="100%" height={400}>
			<AreaChart
				data={filteredData}
				margin={{
					top: 10,
					right: 30,
					left: 0,
					bottom: 0,
				}}
			>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis
					dataKey="timing"
					tick={{ fill: "hsl(var(--foreground))" }}
					axisLine={{ stroke: "hsl(var(--border))" }}
					tickLine={{ stroke: "hsl(var(--border))" }}
				/>
				<YAxis
					tick={{ fill: "hsl(var(--foreground))" }}
					axisLine={{ stroke: "hsl(var(--border))" }}
					tickLine={{ stroke: "hsl(var(--border))" }}
					domain={[0, 48]}
				/>
				<Tooltip content={<ChartTooltip />} />
				<Area
					type="monotone"
					dataKey="value"
					stroke={
						oxfordChartConfig["Oxford Score"]?.color ?? "hsl(var(--chart-3))"
					}
					fill={
						oxfordChartConfig["Oxford Score"]?.color ?? "hsl(var(--chart-3))"
					}
					fillOpacity={0.2}
				/>
			</AreaChart>
		</ResponsiveContainer>
	);
}
